/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ReadMore = 'Website.ProductReview.Header.ReadMore';
export const PercentRecommended = 'Website.ProductReview.Header.PercentRecommended';
